/// <reference path="../system/jquery-1.11.3.min.js" />
/// <reference path="Helper.Url.js" />
/// <reference path="Helper.String.js" />

class HelperUser {
	static getCurrentUserName() {
		const userElement = document.getElementById("meta.CurrentUser");
		return userElement ? userElement.content : null;
	}
	static getCurrentUser() {
		const url = Helper.Url.resolveUrl("~/Users/CurrentUser.json");
		return $.ajax(url, { appendTokenIfRequired: true });
	}

	/**
	 * @param user { {LastName: string, FirstName: string, Email: string} | KnockoutObservable<CrmUser> }
	 * @returns {string}
	 */
	static getDisplayName(user) {
		user = ko.unwrap(user);
		if (user === null) {
			return Helper.String.getTranslatedString("Unspecified");
		}
		const tokens = [];
		if (ko.unwrap(user.LastName)) {
			tokens.push(ko.unwrap(user.LastName));
		}
		if (ko.unwrap(user.FirstName)) {
			tokens.push(ko.unwrap(user.FirstName));
		}
		if (tokens.length < 2 && ko.unwrap(user.Email)) {
			tokens.push(ko.unwrap(user.Email));
		}
		return tokens.join(", ");
	}
	static filterUserQuery(query, term, userGroupId) {
		if (term) {
			query = query.filter(function(it) {
					return it.FirstName.toLowerCase().contains(this.term) ||
						it.LastName.toLowerCase().contains(this.term)||
						it.Id.toLowerCase().contains(this.term);
				},
				{ term: term });
		}
		if (userGroupId) {
			userGroupId = userGroupId.Value || userGroupId;
			if (window.database.storageProvider.name === "webSql") {
				query = query.filter(function(it) {
					return it.UsergroupIds.contains(this.userGroupId);
				}, { userGroupId: `"${userGroupId}"` });
			} else {
				query = query.filter("it.UsergroupObjects.some(function(it2) { return it2.Id === this.userGroupId; })", { userGroupId: userGroupId });
			}
		}
		query = query.filter(function(it) {
			return it.Discharged === false;
		});
		return query;
	}

	static filterUsergroupQueryById(query, term) {
		if (term) {
			query = query.filter(function(it) {
					return it.Id === this.term;
				},
				{ term: term });
		}
		return query;
	}
	static mapForSelect2Display(user) {
		return {
			id: user.Id,
			item: user,
			text: Helper.User.getDisplayName(user)
		};
	}
	static mapRoleForSelect2Display(role) {
		role = Helper.Database.getDatabaseEntity(role);
		return {
			id: role.UId,
			item: role,
			text: Helper.String.getTranslatedString(role.Name, role.Name)
		};
	}
	static mapUsergroupForSelect2Display(usergroup) {
		usergroup = Helper.Database.getDatabaseEntity(usergroup);
		return {
			id: usergroup.Id,
			item: usergroup,
			text: usergroup.Name
		};
	}
	static languageFilter(query,term) {
		query = query.filter("it.IsSystemLanguage === true");
		return Helper.Lookup.queryLookup(query, term);
	}
	
	static async toggleActive(user) {
		try {
			await window.Helper.Confirm.genericConfirm({
				text: window.Helper.String
					.getTranslatedString(user.Discharged() ? "ConfirmActivateUser" : "ConfirmDeactivateUser")
					.replace("{0}", ko.unwrap(user.Id)),
				type: "info"
			});
		} catch {
			return false;
		}
		window.database.attachOrGet(user.innerInstance);
		user.Discharged(!user.Discharged());
		user.DischargeDate(user.Discharged() ? new Date() : null);
		await window.database.saveChanges();
		return true;
	}
	
	static async refreshUserCache() {
		await fetch(window.Helper.Url.resolveUrl("~/UserAdmin/RefreshUserCache"), {redirect: "manual"});
	}

}

(window.Helper = window.Helper || {}).User = HelperUser;
